<template>
  <div class="national-challenges-page">
    <WeCircularNavbar />

    <section class="page-section hero-section">
      <div class="page-container">
        <h1 class="page-title">National challenges</h1>

        <p class="page-intro">
          This section explores national challenges in the Danube Region through the lens of women-led enterprises,
          digitalization, the circular economy and Smart Specialisation Strategies (S3), with a focus on skills needs as
          well as relevant policy and legislative frameworks.
        </p>

        <div class="panel">
          <div class="panel-grid">
            <article class="panel-column">
              <div class="panel-column__content">
                <h2 class="panel-title">Skills Gaps and Needs Analysis</h2>

                <p class="panel-text">
                  The National Skills Needs and Gaps Analysis synthesizes the current state of women entrepreneurs in
                  each WE.Circular country and their specific needs for circular and digital transitions.
                </p>
              </div>

              <ul class="country-list">
                <li v-for="country in skillsCountries" :key="'skills-' + country.name">
                  <a :href="country.file" target="_blank" rel="noopener noreferrer" class="country-link">
                    <span class="policy-card__icon"><img :src="downloadIcon" class="icon" alt=""/></span>
                    <span>{{ country.name }}</span>
                  </a>
                </li>
              </ul>
            </article>

            <article class="panel-column">
              <div class="panel-column__content">
                <h2 class="panel-title">National Level Review – Policy and Legislative Framework</h2>

                <p class="panel-text">
                  The aim of the National Level Review is to map legislative and policy measures to support women's
                  entrepreneurship and facilitate the transition to a circular economy, to critically reflect on them,
                  to synthesise key findings about each WE.Circular country’s legislative and policy environment, and to
                  develop a set of recommendations for future improvements.
                </p>
              </div>

              <ul class="country-list">
                <li v-for="country in policyCountries" :key="'policy-' + country.name">
                  <a :href="country.file" target="_blank" rel="noopener noreferrer" class="country-link">
                    <span class="policy-card__icon"><img :src="downloadIcon" class="icon" alt=""/></span>
                    <span>{{ country.name }}</span>
                  </a>
                </li>
              </ul>
            </article>
          </div>
        </div>
      </div>
    </section>

    <WeCircularFooter />
  </div>
</template>

<script>
import WeCircularNavbar from './WeCircularNavbar.vue'
import WeCircularFooter from './WeCircularFooter.vue'
import downloadIcon from '../../assets/img/we-circular/download_1.svg'

export default {
  name: 'NationalChallengesPage',
  components: {
    WeCircularNavbar,
    WeCircularFooter
  },
  data() {
    return {
      downloadIcon,
      skillsCountries: [
        {
          name: 'Austria',
          file: 'https://vali.hu/static/National_Report_Austria_final_08082024.pdf'
        },
        {
          name: 'Bosnia and Herzegovina',
          file: 'https://vali.hu/static/BiH_National_Report_Draft.pdf'
        },
        {
          name: 'Bulgaria',
          file: 'https://vali.hu/static/D111_National_Skills_Needs_and_Gaps_Analysis_Bulgaria.pdf'
        },
        {
          name: 'Croatia',
          file: 'https://vali.hu/static/National_Report_Croatia_final.pdf'
        },
        {
          name: 'Czech Republic',
          file: 'https://vali.hu/static/National_Report_Czechia_FINAL.pdf'
        },
        {
          name: 'Germany',
          file: 'https://vali.hu/static/WeCircular_National_Report_Germany.pdf'
        },
        {
          name: 'Hungary',
          file: 'https://vali.hu/static/National_Skills_Gaps_and_Needs_Analysis_Hungary.pdf'
        },
        {
          name: 'Moldova',
          file: 'https://vali.hu/static/National_Skills_Gaps_and_Needs_Analysis_Republic_of_Moldova.pdf'
        },
        {
          name: 'Romania',
          file: 'https://vali.hu/static/Romania_Skills_Gaps_and_Needs_National_Analysis.pdf'
        },
        {
          name: 'Serbia',
          file: 'https://vali.hu/static/National_Skills_Gaps_and_Needs_Analysis_Serbia.pdf'
        },
        {
          name: 'Slovakia',
          file: 'https://vali.hu/static/National_report_analysis_Slovakia.pdf'
        },
        {
          name: 'Slovenia',
          file: 'https://vali.hu/static/Skills_Gaps_and_Needs_Analysis_Slovenia.pdf'
        }
      ],
      policyCountries: [
        {
          name: 'Austria',
          file: 'https://vali.hu/static/Policy_and_Legislative_Framework_AUSTRIA_final.pdf'
        },
        {
          name: 'Bosnia and Herzegovina',
          file: 'https://vali.hu/static/BiH_Policy_and_Legislative_Framework_draft.pdf'
        },
        {
          name: 'Bulgaria',
          file: 'https://vali.hu/static/Policy_and_Legislative_Framework_Bulgaria_MZ_2.pdf'
        },
        {
          name: 'Croatia',
          file: 'https://vali.hu/static/Policy_and_Legislative_Framework_Croatia.pdf'
        },
        {
          name: 'Czech Republic',
          file: 'https://vali.hu/static/CZECHIA_Policy_and_Legislative_Framework_FINAL.pdf'
        },
        {
          name: 'Germany',
          file: 'https://vali.hu/static/Policy_and_Legislative_Framework_Germany.pdf'
        },
        {
          name: 'Hungary',
          file: 'https://vali.hu/static/Hungary_Policy_and_Legislative_Framework_Final.pdf'
        },
        {
          name: 'Moldova',
          file: 'https://vali.hu/static/MOLDOVA_Policy_and_Legislative_Framework.pdf'
        },
        {
          name: 'Romania',
          file: 'https://vali.hu/static/Romania_Policy_and_Legislative_Framework.pdf'
        },
        {
          name: 'Serbia',
          file: 'Serbia_Policy_and_Legislative_Framework_Final_(v.2).pdf' // ⚠️ ezt ellenőrizd!
        },
        {
          name: 'Slovakia',
          file: 'https://vali.hu/static/SBA_Policy_and_Legislative_Framework_Slovakia.pdf'
        },
        {
          name: 'Slovenia',
          file: 'https://vali.hu/static/Policy_and_Legislative_Framework_SLOVENIA_final.pdf'
        }
      ]
    }
  }
}
</script>

<style scoped>
.policy-card__icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #005ed9;
  color: #ffffff;
  line-height: 1;
  margin-top: 2px;
  font-size: 11px;
}
.national-challenges-page {
  min-height: 100vh;
  background: #f4f7f8;
  color: #123b66;
  text-align: left;
}

.page-section {
  width: 100%;
}

.page-container {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 40px 32px 64px;
  box-sizing: border-box;
  text-align: left;
}

.hero-section {
  padding-top: 24px;
}

.page-title {
  margin: 0 0 16px;
  font-size: 42px;
  line-height: 1.12;
  font-weight: 700;
  color: #0f4c97;
  text-align: left;
}

.page-intro {
  max-width: 760px;
  margin: 0 0 40px;
  font-size: 18px;
  line-height: 1.7;
  color: #4f6f8f;
  text-align: left;
}

.panel {
  position: relative;
  overflow: hidden;
  border-radius: 22px;
  background: linear-gradient(135deg, #0e5458 0%, #1a6669 55%, #2a7472 100%);
  box-shadow: 0 12px 30px rgba(10, 62, 67, 0.12);
}

.panel::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(
        circle at 8% 20%,
        rgba(20, 102, 104, 0.95) 0,
        rgba(20, 102, 104, 0.95) 13%,
        transparent 14%
      )
      repeat-x,
    radial-gradient(circle at 20% 84%, rgba(120, 183, 176, 0.16) 0, rgba(120, 183, 176, 0.16) 11%, transparent 12%)
      repeat-x;
  background-size: 260px 130px, 220px 110px;
  opacity: 0.9;
  pointer-events: none;
}

.panel-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 56px;
  padding: 42px 44px 58px;
  align-items: start;
}

.panel-column {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.panel-column__content {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 28px;
}

.panel-title {
  margin: 0;
  min-height: 72px;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 600;
  color: #ffffff;
  text-align: left;
}

.panel-text {
  margin: 0;
  min-height: 180px;
  font-size: 17px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.92);
  text-align: left;
}

.country-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.country-list li + li {
  margin-top: 12px;
}

.country-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 500;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.country-link:hover {
  opacity: 0.85;
  transform: translateX(2px);
}

.icon {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  object-fit: contain;
  display: block;
}

@media (max-width: 1024px) {
  .page-title {
    font-size: 34px;
  }

  .panel-grid {
    grid-template-columns: 1fr;
    gap: 36px;
    padding: 34px 30px 42px;
  }

  .panel-title {
    min-height: unset;
    font-size: 24px;
  }

  .panel-text {
    min-height: unset;
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 30px 20px 48px;
  }

  .page-title {
    font-size: 30px;
  }

  .page-intro {
    font-size: 17px;
    line-height: 1.7;
    margin-bottom: 34px;
  }

  .panel-grid {
    padding: 26px 20px 30px;
  }

  .panel-title {
    font-size: 22px;
    text-align: left;
  }

  .panel-text {
    font-size: 15px;
    line-height: 1.7;
    text-align: left;
  }

  .country-link {
    font-size: 15px;
  }
}
</style>
